import type { EventName } from "@lit/react";
import { ConfirmDialog as ConfirmDialogElement, type ConfirmDialogEventMap as _ConfirmDialogEventMap, } from "@vaadin/confirm-dialog/vaadin-confirm-dialog.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ConfirmDialogElement, };
export type ConfirmDialogEventMap = Readonly<{
    onClosed: EventName<_ConfirmDialogEventMap["closed"]>;
    onCancel: EventName<_ConfirmDialogEventMap["cancel"]>;
    onConfirm: EventName<_ConfirmDialogEventMap["confirm"]>;
    onReject: EventName<_ConfirmDialogEventMap["reject"]>;
    onOpenedChanged: EventName<_ConfirmDialogEventMap["opened-changed"]>;
}>;
const events = { onClosed: "closed", onCancel: "cancel", onConfirm: "confirm", onReject: "reject", onOpenedChanged: "opened-changed" } as ConfirmDialogEventMap;
export type ConfirmDialogProps = WebComponentProps<ConfirmDialogElement, ConfirmDialogEventMap>;
export const ConfirmDialog = createComponent({
    elementClass: ConfirmDialogElement, events, react: React, tagName: "vaadin-confirm-dialog"
});
